import styled from "styled-components";
import { NoUserAvatar, DefaultAvatar, UserAvatarImg } from "../UserAvatar/UserAvatar.styles";

export const StackedAvatarsContainer = styled.div`
  display: flex;
  flexDirection: row;
  width: 240px;
  height: var(--stacked-avatar-size);
  position: relative;

  ${NoUserAvatar} {
    width: var(--stacked-avatar-size);
    height: var(--stacked-avatar-size);
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(18, 42, 66, 0.03);
  }

  ${DefaultAvatar} {
    font-size: 30px;
  }

  ${UserAvatarImg} {
    width: var(--stacked-avatar-size);
    height: var(--stacked-avatar-size);
  }
`

export const FirstAvatar = styled.div`
  position: absolute;
  z-index: 1;
  left: calc((var(--stacked-avatar-size) - 15px) * 4);
`

export const SecondAvatar = styled.div`
  position: absolute;
  z-index: 2;
  left: calc((var(--stacked-avatar-size) - 15px) * 3);
`

export const ThirdAvatar = styled.div`
  position: absolute;
  z-index: 3;
  left: calc((var(--stacked-avatar-size) - 15px) * 2);
`

export const FourthAvatar = styled.div`
  position: absolute;
  z-index: 4;
  left: calc(var(--stacked-avatar-size) - 15px);
`

export const FifthAvatar = styled.div`
  position: absolute;
  z-index: 5;
  left: 0;
`